let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("gGI57"), load("6kvlj"), load("aZinD"), load("iaptT")]).then(() => parcelRequire('hB4M9'));